import styled from 'styled-components';

import { basicSmallTextStyle, StyledFlex } from '@dreryk/react-components';

export const StyledNotificationMessage = styled.span`
   ${basicSmallTextStyle}
   color: ${(props) => props.theme.textBody};
`;
StyledNotificationMessage.displayName = 'StyledNotificationMessage';

export const StyledNotificationResource = styled.span`
   color: ${(props) => props.theme.borderDark};
   font-size: 12px;
`;
StyledNotificationResource.displayName = 'StyledNotificationResource';

export const StyledNotificationDate = styled.time`
   color: ${(props) => props.theme.borderDark};
   font-size: 12px;
   line-height: 14px;
`;
StyledNotificationDate.displayName = 'StyledNotificationDate';

export const StyledNotificationUnreadDot = styled.span`
   flex-shrink: 0;
   width: 10px;
   height: 10px;
   margin-right: -6px;
   border-radius: 50%;
   background: ${(props) => props.theme.errorDark};
`;
StyledNotificationUnreadDot.displayName = 'StyledNotificationUnreadDot';

export const StyledNotificationItemContainer = styled(StyledFlex)`
   padding: 2px 0;
`;
StyledNotificationItemContainer.displayName = 'StyledNotificationItemContainer';

export const StyledNotificationChevron = styled.span`
   display: inline-flex;
   flex-shrink: 0;
   width: 20px;
   height: 20px;
   color: ${(props) => props.theme.primary};

   svg path {
      fill: currentColor;
   }
`;
StyledNotificationChevron.displayName = 'StyledNotificationChevron';
